import * as HLF from "html-living-framework";
import * as SoundEffect from "../Data/SoundEffect";
import * as Topics from "../Data/Topics";
import { Patch } from "../GameObjects/Patch";
import { PatchFactory } from "../Utils/PatchFactory";

export class PatchDraggable extends HLF.Input.Draggable {
    private static MAX_SIZE: PIXI.Point = new PIXI.Point(220, 220);
    private _patch!: Patch;
    private _preview!: Patch;
    private _scale!: number;
    private _quiltIndex: number;

    constructor(pIndex: number, pExclude: string[]) {
        super();
        this._quiltIndex = pIndex;

        this.randomizePatch(pExclude);
    }

    public set quiltIndex(pValue: number) {
        this._quiltIndex = pValue;
    }

    public get patch(): Patch {
        return this._patch;
    }

    public onFocusBegin(): void {
        super.onFocusBegin();
        PubSub.publishSync(Topics.KEYBOARD_FOCUS_BEGIN, this);
    }

    public onFocusEnd(): void {
        super.onFocusEnd();
        PubSub.publishSync(Topics.KEYBOARD_FOCUS_END, this);
    }

    public getFocusPosition(): PIXI.Point {
        return this.getGlobalPosition();
    }

    public getFocusSize(): PIXI.Point {
        return new PIXI.Point(this.width, this.height);
    }

    public randomizePatch(pExclude: string[]): void {
        if (this._patch !== undefined) {
            this._visuals.removeChild(this._patch);
        }
        this._patch = PatchFactory.random(this._quiltIndex, pExclude);
        this._preview = this._patch.clone();

        const width: number = Math.min(PatchDraggable.MAX_SIZE.x, this._patch.width);
        const height: number = Math.min(PatchDraggable.MAX_SIZE.y, this._patch.height);
        this._scale = Math.min(width / this._patch.width, height / this._patch.height);

        this._patch.scale.set(0.65 * this._scale);
        this._patch.position.set(-this._patch.width * 0.5, -this._patch.height * 0.5);
        this._visuals.addChild(this._patch);

        this.hitArea = new PIXI.Rectangle(
            -this._patch.width * 0.5 - 10,
            -this._patch.height * 0.5 - 10,
            this._patch.width + 20,
            this._patch.height + 20,
        );
    }

    public get preview(): Patch {
        return this._preview;
    }

    public select(): void {
        super.select();

        PubSub.publishSync(Topics.PATCH_SELECTED, undefined);
        PubSub.publishSync(HLF.PLAY_AUDIO, new HLF.AudioToken(
            SoundEffect.SELECT_PATCH,
            1, false, HLF.AudioCategory.SFX,
        ));
    }

    public deselect(): void {
        super.deselect();
        PubSub.publishSync(Topics.PATCH_DESELECTED, undefined);
    }

    protected dragBegin(): void {
        super.dragBegin();
        this._patch.scale.set(1);
        PubSub.publishSync(Topics.PATCH_SELECTED, undefined);
    }

    protected dragEnd(): void {
        super.dragEnd();
        this._patch.scale.set(0.65 * this._scale);

        this._visuals.position.set(0);
        PubSub.publishSync(Topics.PATCH_DESELECTED, undefined);
    }
}
